import {Component, Input, OnInit, ViewChild, ElementRef} from '@angular/core';
import hljs from 'highlight.js/lib/core';
import json from 'highlight.js/lib/languages/json';
import xml from 'highlight.js/lib/languages/xml';

@Component({
  selector: 'sample-responses',
  templateUrl: './sample-responses.component.html',
  styleUrls: ['./sample-responses.component.scss', '../response-display.scss']
})
export class SampleResponsesComponent implements OnInit {

  @Input() responses;

  constructor() { }

  ngOnInit(): void {
    hljs.registerLanguage('json', json);
    hljs.registerLanguage('xml', xml);
  }

  getContentType(headers): string {
    if (headers) {
      const contentTypeHeader = headers.find(header => header.name.toLowerCase() === 'content-type');
      if (contentTypeHeader) {
        const contentType = contentTypeHeader.value.toLowerCase();
        if (contentType === 'application/json') {
          return 'json';
        } else if (contentType === 'application/xml') {
          return 'xml';
        }
      }
    }
    return 'text';
  }

  getStatusColor(statusCode: number): string {
    if (statusCode >= 100 && statusCode < 200) {
      return 'i';
    } else if (statusCode >= 200 && statusCode < 300) {
      return 's';
    } else if (statusCode >= 300 && statusCode < 400) {
      return 'r';
    } else if (statusCode >= 400 && statusCode < 500) {
      return 'c';
    } else if (statusCode >= 500 && statusCode < 600) {
      return 'e';
    } else {
      return '';
    }
  }

  getJsonvalue(value) {
    if (value) {
      try {
        const jsonString = JSON.stringify(value, null, 2);
        return hljs.highlight('json', jsonString).value;
      } catch {
        return value;
      }
    }
    return '';
  }

  getXMLvalue(value) {
    if (value) {
      try {
        const xmlString = value;
        return hljs.highlight('xml', xmlString).value;
      } catch {
        return value;
      }
    }
    return '';
  }

}
